"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HeaderFieldsDict = exports.HeaderFieldsEnum = void 0;
var HeaderFieldsEnum;
(function (HeaderFieldsEnum) {
    HeaderFieldsEnum["COMPANY_NAME"] = "companyName";
    HeaderFieldsEnum["COMPANY_ID"] = "companyId";
    HeaderFieldsEnum["EXPENSE_NUMBER"] = "expenseNumber";
    HeaderFieldsEnum["KIND"] = "kind";
    HeaderFieldsEnum["DATE_PURCHASED"] = "datePurchased";
    HeaderFieldsEnum["NAME"] = "name";
    HeaderFieldsEnum["DESCRIPTION"] = "description";
    HeaderFieldsEnum["TOTAL_GROSS_PRICE"] = "totalGrossPrice";
    HeaderFieldsEnum["TOTAL_NET_PRICE"] = "totalNetPrice";
    HeaderFieldsEnum["TOTAL_TAX"] = "totalTax";
    HeaderFieldsEnum["TAX_VALUE"] = "taxValue";
    HeaderFieldsEnum["CURRENCY"] = "currency";
    HeaderFieldsEnum["COST_CENTER"] = "costCenter";
    HeaderFieldsEnum["COST_CENTER_ID"] = "costCenterId";
    HeaderFieldsEnum["COST_CENTER2_NAME"] = "costCenter2Name";
    HeaderFieldsEnum["COST_CENTER2_CODE"] = "costCenter2Code";
    HeaderFieldsEnum["REQUESTED_BY"] = "requestedBy";
    HeaderFieldsEnum["APPROVED_BY"] = "approvedBy";
    HeaderFieldsEnum["INVOICE_FILES"] = "invoiceFiles";
    HeaderFieldsEnum["DELIVERY_NOTE_FILES"] = "deliveryNoteFiles";
    HeaderFieldsEnum["INVOICE_NUMBER"] = "invoiceNumber";
    HeaderFieldsEnum["INVOICE_DATE"] = "invoiceDate";
    HeaderFieldsEnum["INVOICE_DUE_DATE"] = "invoiceDueDate";
    HeaderFieldsEnum["DATE_PAID_AT"] = "datePaidAt";
    HeaderFieldsEnum["EXPENSE_ACCOUNT_NAME"] = "expenseAccountName";
    HeaderFieldsEnum["EXPENSE_ACCOUNT_CODE"] = "expenseAccountCode";
    HeaderFieldsEnum["STATUS"] = "status";
    HeaderFieldsEnum["VENDOR"] = "vendor";
    HeaderFieldsEnum["VENDOR_CREDITOR_NUMBER"] = "vendorCreditorNumber";
    HeaderFieldsEnum["VENDOR_ADDRESS"] = "vendorAddress";
    HeaderFieldsEnum["VENDOR_DESCRIPTION"] = "vendorDescription";
    HeaderFieldsEnum["VENDOR_VAT"] = "vendorVat";
    HeaderFieldsEnum["VENDOR_TAX_ID"] = "vendorTaxId";
    HeaderFieldsEnum["VENDOR_IBAN"] = "vendorIban";
    HeaderFieldsEnum["VENDOR_BIC"] = "vendorBic";
    HeaderFieldsEnum["VENDOR_CONTACT_PERSON"] = "vendorContactPerson";
    HeaderFieldsEnum["MILEAGE_ADDRESSES"] = "mileageAddresses";
    HeaderFieldsEnum["MILEAGE_DISTANCE"] = "mileageDistance";
    HeaderFieldsEnum["MILEAGE_VEHICLE"] = "vehicle";
    HeaderFieldsEnum["MILEAGE_RATE"] = "customMileageRate";
    HeaderFieldsEnum["HOSPITALITY_ATTENDEES"] = "attendees";
    HeaderFieldsEnum["HOSPITALITY_MERCHANT"] = "merchant";
    HeaderFieldsEnum["PER_DIEM_DESTINATIONS"] = "destinations";
    HeaderFieldsEnum["PER_DIEM_START_DATE"] = "startDate";
    HeaderFieldsEnum["PER_DIEM_START_TIME"] = "startTime";
    HeaderFieldsEnum["PER_DIEM_END_DATE"] = "endDate";
    HeaderFieldsEnum["PER_DIEM_END_TIME"] = "endTime";
    HeaderFieldsEnum["PERFORMANCE_PERIOD_START"] = "performancePeriodStart";
    HeaderFieldsEnum["PERFORMANCE_PERIOD_END"] = "performancePeriodEnd";
})(HeaderFieldsEnum = exports.HeaderFieldsEnum || (exports.HeaderFieldsEnum = {}));
exports.HeaderFieldsDict = {
    [HeaderFieldsEnum.COMPANY_NAME]: 'Company Name',
    [HeaderFieldsEnum.COMPANY_ID]: 'Company ID',
    [HeaderFieldsEnum.EXPENSE_NUMBER]: 'Expense Number',
    [HeaderFieldsEnum.KIND]: 'Kind',
    [HeaderFieldsEnum.DATE_PURCHASED]: 'Performance Date',
    [HeaderFieldsEnum.NAME]: 'Items/Subscription',
    [HeaderFieldsEnum.DESCRIPTION]: 'Description',
    [HeaderFieldsEnum.TOTAL_GROSS_PRICE]: 'Gross Amount',
    [HeaderFieldsEnum.TOTAL_NET_PRICE]: 'Net Amount',
    [HeaderFieldsEnum.TOTAL_TAX]: 'Total Tax Amount',
    [HeaderFieldsEnum.TAX_VALUE]: 'Tax Value(s)',
    [HeaderFieldsEnum.CURRENCY]: 'Currency',
    [HeaderFieldsEnum.COST_CENTER]: 'Cost Center 1',
    [HeaderFieldsEnum.COST_CENTER_ID]: 'Cost Center 1 ID',
    [HeaderFieldsEnum.COST_CENTER2_NAME]: 'Cost Center 2',
    [HeaderFieldsEnum.COST_CENTER2_CODE]: 'Cost Center 2 Code',
    [HeaderFieldsEnum.REQUESTED_BY]: 'Requested By',
    [HeaderFieldsEnum.APPROVED_BY]: 'Approval Needed By',
    [HeaderFieldsEnum.INVOICE_FILES]: 'Invoice Files',
    [HeaderFieldsEnum.DELIVERY_NOTE_FILES]: 'Delivery Note File',
    [HeaderFieldsEnum.INVOICE_NUMBER]: 'Invoice Number',
    [HeaderFieldsEnum.INVOICE_DATE]: 'Invoice Date',
    [HeaderFieldsEnum.INVOICE_DUE_DATE]: 'Invoice Due Date',
    [HeaderFieldsEnum.DATE_PAID_AT]: 'Paid At Date',
    [HeaderFieldsEnum.EXPENSE_ACCOUNT_NAME]: 'Expense Account Name',
    [HeaderFieldsEnum.EXPENSE_ACCOUNT_CODE]: 'Expense Account Code',
    [HeaderFieldsEnum.STATUS]: 'Status',
    [HeaderFieldsEnum.VENDOR]: 'Vendor',
    [HeaderFieldsEnum.VENDOR_CREDITOR_NUMBER]: 'Vendor Creditor Number',
    [HeaderFieldsEnum.VENDOR_ADDRESS]: 'Vendor Address',
    [HeaderFieldsEnum.VENDOR_DESCRIPTION]: 'Vendor Description',
    [HeaderFieldsEnum.VENDOR_VAT]: 'Vendor VAT',
    [HeaderFieldsEnum.VENDOR_TAX_ID]: 'Vendor Tax ID',
    [HeaderFieldsEnum.VENDOR_IBAN]: 'Vendor IBAN',
    [HeaderFieldsEnum.VENDOR_BIC]: 'Vendor BIC',
    [HeaderFieldsEnum.VENDOR_CONTACT_PERSON]: 'Vendor Contact Person',
    [HeaderFieldsEnum.MILEAGE_ADDRESSES]: 'Mileage Destination Address(es)',
    [HeaderFieldsEnum.MILEAGE_DISTANCE]: 'Distance',
    [HeaderFieldsEnum.MILEAGE_VEHICLE]: 'Vehicle',
    [HeaderFieldsEnum.MILEAGE_RATE]: 'Custom Mileage Rate',
    [HeaderFieldsEnum.HOSPITALITY_ATTENDEES]: 'Hospitality Attendees',
    [HeaderFieldsEnum.HOSPITALITY_MERCHANT]: 'Hospitality Merchant',
    [HeaderFieldsEnum.PER_DIEM_DESTINATIONS]: 'Per diem destinations',
    [HeaderFieldsEnum.PER_DIEM_START_DATE]: 'Per Diem Start Date',
    [HeaderFieldsEnum.PER_DIEM_START_TIME]: 'Per Diem Start Time',
    [HeaderFieldsEnum.PERFORMANCE_PERIOD_END]: 'Performance-Period End',
    [HeaderFieldsEnum.PERFORMANCE_PERIOD_START]: 'Performance-Period Start',
    [HeaderFieldsEnum.PER_DIEM_END_DATE]: 'Per Diem Return Date',
    [HeaderFieldsEnum.PER_DIEM_END_TIME]: 'Per Diem Return Time',
};
